import React from "react";
import { is_franchise_admin, is_franchise_manager, is_franchise_staff, is_superuser } from "../../Functionalities/Config";
import ProductImage from "./ProductImage";
import ProductControls from "./ProductControls";
import "./ProductCard.css";

export default function ProductCard({ item, index, toggle, toggleSale, toggleTempUnavailable }) {
  const link = `/productID/${item.id}`;
  const seesRestaurant = is_superuser || is_franchise_admin || is_franchise_manager || is_franchise_staff;

  return (
    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
      <div className="card">
        <div className="card-body pc-body">
          <div className="new-arrival-product">
            <ProductImage item={item} />
            <div className="new-arrival-content text-center mt-3">
              <h4><a href={link}>{item.name}</a></h4>
              {item.on_sale && item.sale_discount ? (
                <span className="badge badge-warning mb-1">Sale {item.sale_discount}%</span>
              ) : null}
              {seesRestaurant && <h6><a href={link}>{item.branch?.name}</a></h6>}
              {item.ratings ? (
                <div className="pc-rating">
                  <i className="fa fa-star text-primary" /> {item.ratings.toFixed(0)}
                </div>
              ) : null}
              <ProductControls
                item={item}
                index={index}
                toggle={toggle}
                toggleSale={toggleSale}
                toggleTempUnavailable={toggleTempUnavailable}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
